import { MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';

export const MY_DATE_FORMATS = {
    ...MAT_LUXON_DATE_FORMATS,
    parse: {
        ...MAT_LUXON_DATE_FORMATS.parse,
        dateInput: ['dd/LL/yyyy', 'd/L/yyyy'],
    },
    display: {
        ...MAT_LUXON_DATE_FORMATS.display,
        dateInput: 'dd/LL/yyyy', // Personalize o formato de entrada de data aqui
    },
};
